import React, { Component } from 'react'
import { Col, Glyphicon, OverlayTrigger, Popover, Button } from 'react-bootstrap'
import Hours from './Hours'
import { connect } from 'react-redux'

class WorkloadTrackerRow extends Component {

  findHour = (hours, parentObjectName, url, date, type) => {
    // hours is an array of hours objects, either the saved proposalHours or projectHours, of inputtedHours, which have not yet been saved
    // parentObjectName is the type of hour ex 'project' or 'proposal'
    // type is either 'Actual' or 'Projected'

    return hours.find(hour => {
			let parentObjectsAreEqual =  hour[parentObjectName] && hour[parentObjectName].url === url
      const hourDate = new Date(hour.date.replace(/-/g, "/")).toLocaleDateString()
			let datesAreEqual = hourDate === date
			let typesAreEqual = hour.type === type
			return parentObjectsAreEqual && datesAreEqual && typesAreEqual
		})
  }

  getHour = (url, parentObjectName, date, type) => {
    // parentObjectName is the type of hour ex 'project' or 'proposal'

    const { inputtedHours } = this.props

    const savedHoursType = this.props[`${parentObjectName}Hours`]

		const userInputHours = this.findHour(inputtedHours, parentObjectName, url, date, type)

		if (userInputHours) {
			return userInputHours.hours
		}

		let savedHours = this.findHour(savedHoursType, parentObjectName, url, date, type)

		if (savedHours) {
			return savedHours.hours
		} else {
      return '0.0'
    }
	}

  truncateText = (str, length, ending) => {
    if (length == null) {
      length = 100;
    }
    if (ending == null) {
      ending = '...';
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  }

  getParentObjectString = () => {
    const { parentObject, parentObjectName } = this.props
    let title = ""
    if (parentObjectName === "project") {
      title = `${parentObject.short_id}-${parentObject.number}-${parentObject.title}`
      return this.truncateText(title)
    } else if (parentObjectName === "proposal") {
      if (parentObject.client) {
        title = `${parentObject.client.name}-${parentObject.client.short_code}-${parentObject.number} - ${parentObject.title}`
        return this.truncateText(title)
      } else {
        title = `${parentObject.number}-${parentObject.title}`
        return this.truncateText(title)
      }
    }
  }

  render () {
    const { parentObject, parentObjectName, type, readOnly } = this.props

    let allRowHours = this.props.dayDates.map(date => {
      const hour = this.getHour(parentObject.url, parentObjectName, date, type)
      return (
        <Hours
          key={date}
          date={date}
          type={type}
          parentObject={parentObject}
          parentObjectName={parentObjectName}
          hour={hour}
          readOnly={readOnly}
        />
      )
    })

    let totalHours = (
      <td
        key={`${parentObject.id}-${this.props.index}`}
        style={{textAlign:"center", verticalAlign:"middle"}}
      >
        {this.props.totalHours}
      </td>
    )

    allRowHours = [...allRowHours, totalHours]


    const removeHoursPopover = (
      <Popover id="remove-hours-popover" title="Remove hours?">
        <p>
        The hours for this {parentObjectName} will be deleted from the database when the Submit button below is clicked,
        </p>
        <br/>
        <center>
          <Button onClick={() => this.props.handleRemove(parentObject)}>
            Remove Hours
          </Button>
        </center>
      </Popover>
    )


    return (
      <tr>
        <td
          key={this.props.index}
          style={{
            borderRight:"thin solid #dcdbdc",
            verticalAlign:"middle",
            width:"30vw"
          }}
        >
          <Col xs={10} sm={10} md={10}>
            {this.getParentObjectString()}
          </Col>
          <Col xs={2} sm={2} md={2}>
            <OverlayTrigger
              trigger="click"
              rootClose
              placement="right"
              overlay={removeHoursPopover}
            >
              <Glyphicon glyph="glyphicon glyphicon-remove" />
            </OverlayTrigger>
          </Col>
        </td>
        {allRowHours}
      </tr>
    )
  }
}

const mapStateToProps = (state) => {
  return {
		inputtedHours: state.manageHours.inputtedHours,
    projectHours: state.manageHours.projectHours,
    proposalHours: state.manageHours.proposalHours,
  }
}

export default connect(mapStateToProps)(WorkloadTrackerRow);



// WEBPACK FOOTER //
// ./src/routes/workload/components/WorkloadTrackerRow.js